var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStage3Top(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_44150",
    "data-name": "Group 44150",
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.853,
    height: 206.72,
    viewBox: "0 0 185.853 206.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9564",
    "data-name": "Path 9564",
    d: "M181.19,210.2c-.436,1.539-.816,5.9-1.422,11.545-.538,5.075-5.731,23.953-6.275,25.862-3.423,12.074-10.847,22.183-18.529,23.363-8.708,1.339-23.655,4.905-29.09,10.581-.113.118-.221.241-.328.369-4.741,5.691-6.855,15.189-17.159,16.318-10.309-1.124-12.423-10.622-17.164-16.318-.107-.128-.221-.257-.344-.38-5.439-5.664-20.371-9.231-29.074-10.57-7.687-1.18-15.112-10.792-18.534-22.87a50.934,50.934,0,0,1-1.309-5.865c-.544-3.356-4.423-15.419-4.962-20.489-.606-5.649-.991-10.006-1.427-11.545-.734-2.591,35.555.318,72.813,3.967,37.253-3.648,73.536-6.558,72.8-3.967",
    transform: "translate(-15.556 -91.516)",
    fill: "#d3b1a7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9565",
    "data-name": "Path 9565",
    d: "M179.385,227.085l-4.875,16.677s-2.566,8.98-4.362,13.6-15.137,13.085-18.729,18.472-12.9,8.836-21.839,13.526c-.37.2-.76.375-1.175.544-4.023,1.647-10.191,2.263-16.035,2.422-5.844-.159-12.012-.775-16.035-2.422-.416-.169-.806-.349-1.175-.544-8.944-4.69-18.247-8.138-21.839-13.526S56.388,261.978,54.592,257.36s-4.362-13.6-4.362-13.6l-4.875-16.677,67.015,5.537Z",
    transform: "translate(-19.841 -99.336)",
    fill: "#efcabf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9566",
    "data-name": "Path 9566",
    d: "M182.276,80C174.808,33.2,149.208.042,101.812.042h-.007C100.984.017,100.16,0,99.331,0c-47.4,0-73,33.16-80.464,79.963-5.37,33.653,7.244,56.948,28.564,72.3,3.992,2.874,10.171,4.876,16.249,6.582,9.751,6.166,17.25,11.243,34.508,11.865.186.007.374.012.563.016,1,.03,2.022.05,3.09.05a25.114,25.114,0,0,0,3.22-.2c15.653-.937,22.939-5.776,32.175-11.621,6.151-1.72,12.436-3.735,16.478-6.646,21.321-15.353,33.934-38.649,28.564-72.3",
    transform: "translate(-7.713 -0.001)",
    fill: "#060606"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9567",
    "data-name": "Path 9567",
    d: "M299.706,197.745s11.145-6.023,11.145,0S300.588,215.9,297.51,220.61s-11.758,7.253-11.758,7.253Z",
    transform: "translate(-124.998 -85.331)",
    fill: "#e5bfb1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9568",
    "data-name": "Path 9568",
    d: "M11.145,190.448S0,184.425,0,190.448,10.263,208.6,13.342,213.312,25.1,220.566,25.1,220.566Z",
    transform: "translate(0 -82.139)",
    fill: "#e5bfb1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9569",
    "data-name": "Path 9569",
    d: "M165.505,192.947c-3.176-2.162-4.722.37-5.78,5.4-.3.008-.559.423-.766,1.4-1.968,9.322-5.821,42.081-42.813,43.5s-45.168-47.564-45.168-47.564-.167.248-.438.671c-1.063-5.5-2.6-8.374-5.924-6.112-11.536,7.855-10.61,37.063-10.61,37.063l17.708,17.78s1.675.562,4.155,1.364c5.375,7.776,10.232,13.8,10.232,13.8l30.374,6.925c16.339,3.726,29.906-7.36,38.963-18.4,1.811-.592,2.97-.979,2.97-.979l17.708-17.781s.927-29.209-10.61-37.063",
    transform: "translate(-23.617 -82.881)",
    fill: "#efcabf"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9570",
    "data-name": "Path 9570",
    d: "M172.547,64.159c0,7.97-8.15,14.431-18.2,14.431s-18.2-6.46-18.2-14.431,8.15-14.431,18.2-14.431,18.2,6.46,18.2,14.431",
    transform: "translate(-62.037 -41.763)",
    fill: "#efcabf"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11605",
    "data-name": "Path 11605",
    d: "M-13074.155-1063.8s15.705-26.142,34.01-21.723,19.645,11.322,26.365,21.723,25.011,13.888,34.477,0,3.886-15.411,20.394-21.723a26.976,26.976,0,0,1,34.915,14.285c4.421,10.732-29.036,43.557-29.036,43.557l-87.114,4.419-26.4-25.418-3.915-5.781Z",
    transform: "translate(13094.161 1191.546)",
    fill: "#efcabf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage3Top);
export default __webpack_public_path__ + "static/media/stage3_top.93307559cc41ccc575026b23558c388f.svg";
export { ForwardRef as ReactComponent };